var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCloseDefault = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 12 12",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.258 5.981 3.869-3.83.788-.79c.113-.112.113-.3 0-.45L11.09.085c-.15-.113-.338-.113-.45 0L6.02 4.742 1.36.085c-.112-.113-.3-.113-.45 0L.085.91c-.113.15-.113.338 0 .45l4.657 4.62-4.657 4.66c-.113.112-.113.3 0 .45l.826.826c.15.113.338.113.45 0L6.02 7.259l3.83 3.869.79.788c.112.113.3.113.45 0l.826-.826c.113-.15.113-.338 0-.45z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseDefault);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;